<template>
  <b-overlay :show="AllTickets === null" rounded="sm">
    <div v-if="AllTickets !== null">
      <!-- Filter Section -->
      <b-card class="mb-3">
        <b-row>
          <b-col cols="12" md="4">
            <b-form-group label="جستجو" label-for="search-input">
              <b-form-input
                  id="search-input"
                  v-model="search"
                  type="text"
                  placeholder="جستجو بر اساس عنوان یا نام کاربر..."
              />
            </b-form-group>
          </b-col>

          <b-col cols="12" md="4">
            <b-form-group label="نوع تیکت" label-for="type-filter">
              <b-form-select
                  id="type-filter"
                  v-model="TicketType"
                  :options="ticketTypeOptions"
              />
            </b-form-group>
          </b-col>

<!--          <b-col cols="12" md="4">-->
<!--            <b-form-group label="وضعیت" label-for="status-filter">-->
<!--              <b-form-select-->
<!--                  id="status-filter"-->
<!--                  v-model="selectedStatus"-->
<!--                  :options="statusOptions"-->
<!--              />-->
<!--            </b-form-group>-->
<!--          </b-col>-->
        </b-row>
      </b-card>

      <!-- Table Container Card -->
      <b-card class="mb-0">
        <h1>لیست تیکت ها</h1>
        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="AllTickets"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
        >
          <template #cell(id)="data">
            {{ data.item.id }}
          </template>

          <template #cell(user)="data">
            <p>
              {{ (data.item.user && data.item.user.fullName) || 'نامشخص' }}
            </p>
            <small class="text-muted">{{ (data.item.user && data.item.user.phoneNumber) || '' }}</small>
          </template>

          <template #cell(ticketType)="data">
            <span
                class="badge pill text-white"
                :class="getTicketTypeClass(data.item.ticketType)"
            >
              {{ getTicketTypeLabel(data.item.ticketType) }}
            </span>
          </template>

          <template #cell(status)="data">
            <b-badge :variant="getStatusVariant(data.item.status)">
              {{ getStatusLabel(data.item.status) }}
            </b-badge>
          </template>

          <template #cell(createdAt)="data">
            {{ formatDate(data.item.createdAt) }}
          </template>

          <template #cell(actions)="data">
            <b-link
                class="cursor-pointer"
                :to="`/apps/ticketDetail/${data.item.id}`"
            >
              <feather-icon icon="EyeIcon" size="20" class="text-primary" />
            </b-link>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">نمایش {{ ((currentPage - 1) * perPage) + 1 }} تا {{ Math.min(currentPage * perPage, totalCount) }} از {{ totalCount }} تیکت</span>
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalCount"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                      style="transform: rotate(180deg)"
                      icon="ChevronLeftIcon"
                      size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
  BModal,
  BFormGroup,
  BFormSelect,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { TicketGetAllRequest } from "@/libs/Api/Ticket";

import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
  title: "تیکت ها  - پنل ادمین فرمن",
  name: "UsersList",
  data() {
    return {
      AllTickets: null,
      totalCount: null,
      showDeleteModal: false,
      currentPage: 1,
      deleteItem: null,
      perPage: 10,
      CategoryName: "",
      TicketType: "",
      selectedStatus: "",
      searchTimeout: null,
      perPageOptions: [10, 20, 30, 40, 50],
      ticketTypeOptions: [
        { value: "", text: "همه انواع تیکت" },
        { value: "Financial", text: "مالی و پرداخت" },
        { value: "Courses", text: "مشاهده و دانلود آموزش ها" },
        { value: "Masters", text: "تدریس و مدرس ها" },
        { value: "Other", text: "سایر" },
      ],
      statusOptions: [
        { value: "", text: "همه وضعیت‌ها" },
        { value: "WaitingForSupport", text: "منتظر پاسخ" },
        { value: "WaitingForUser", text: "منتظر پاسخ کاربر" },
        { value: "Closed", text: "بسته شده" },
        { value: "InProgress", text: "در حال بررسی" },
      ],
      myTableColumns: [
        {
          key: "id",
          label: "شناسه",
          sortable: true,
        },
        {
          key: "title",
          label: "موضوع",
          sortable: true,
        },
        {
          key: "user",
          label: "توسط",
        },
        {
          key: "ticketType",
          label: "نوع تیکت",
        },
        {
          key: "status",
          label: "وضعیت",
        },
        {
          key: "createdAt",
          label: "تاریخ ایجاد",
          sortable: true,
        },
        {
          key: "actions",
          label: "مشاهده",
        },
      ],

      pageNumber: 1,
      count: 10,
      search: "",
      SelectedTicket: null,
    };
  },
  async created() {
    await this.GetAllTicket();
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    BModal,
    BFormSelect,
    vSelect,
  },
  watch: {
    search: function() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.GetAllTicket();
      }, 500);
    },
    currentPage: function() {
      this.GetAllTicket();
    },
    TicketType: function() {
      this.currentPage = 1;
      this.GetAllTicket();
    },
    selectedStatus: function() {
      this.currentPage = 1;
      this.GetAllTicket();
    },
  },
  methods: {
    async GetAllTicket() {
      let _this = this;
      let ticketGetAllRequest = new TicketGetAllRequest(_this);
      let data = {
        pageNumber: _this.currentPage,
        count: _this.count,
        search: _this.search,
        type: _this.TicketType,
        status: _this.selectedStatus,
      };
      ticketGetAllRequest.setParams(data);
      await ticketGetAllRequest.fetch(
          function (content) {
            _this.AllTickets = content.data.data;
            _this.totalCount = content.data.totalCount;
          },
          function (error) {
            console.log(error);
          }
      );
    },

    getTicketTypeLabel(type) {
      const labels = {
        'Financial': 'مالی و پرداخت',
        'Courses': 'مشاهده و دانلود آموزش ها',
        'Masters': 'تدریس و مدرس ها',
        'Expert': 'متخصصین',
        'Other': 'سایر'
      };
      return labels[type] || type || 'نامشخص';
    },

    getTicketTypeClass(type) {
      const classes = {
        'Financial': 'bg-warning',
        'Courses': 'bg-info',
        'Masters': 'bg-success',
        'Expert': 'bg-primary',
        'Other': 'bg-secondary'
      };
      return classes[type] || 'bg-secondary';
    },

    getStatusLabel(status) {
      const labels = {
        'WaitingForSupport': 'منتظر پاسخ',
        'WaitingForUser': 'منتظر پاسخ کاربر',
        'Closed': 'بسته شده',
        'InProgress': 'در حال بررسی'
      };
      return labels[status] || status || 'نامشخص';
    },

    getStatusVariant(status) {
      const variants = {
        'WaitingForSupport': 'warning',
        'WaitingForUser': 'info',
        'Closed': 'secondary',
        'InProgress': 'primary'
      };
      return variants[status] || 'secondary';
    },

    formatDate(dateString) {
      if (!dateString) return 'نامشخص';
      const date = new Date(dateString);
      return new Intl.DateTimeFormat('fa-IR').format(date);
    },
  },
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>
